import LinearProgress from '@mui/material/LinearProgress';
export default function LinearLoaderBar(){
return (
    <>
    <div className='linearLoaderBox'>
        <LinearProgress/>
    </div>
    </>
);
}
